// HANDLE SWATCHES FOR DEFAULT PDP
document.addEventListener("DOMContentLoaded", function () {
      const materialLabels = document.querySelectorAll('label.variant-option-Material, label[class*="variant-option-material"]');

      materialLabels.forEach((label) => {
        label.addEventListener("click", function (e) {
          if (e.target.closest('.icon-eye-view')) return;

          setTimeout(() => {
            const container = label.closest('form') || document;
            const colorFieldset = container.querySelector('fieldset.fieldset-Color');
            if (!colorFieldset) return;

            const colorInputs = colorFieldset.querySelectorAll('input[type="radio"]');
            const firstAvailableColorInput = Array.from(colorInputs).find(input =>
              input &&
              input.id &&
              !input.disabled &&
              !input.classList.contains('disabled') &&
              input.offsetParent !== null
            );

            if (firstAvailableColorInput) {
              const colorLabel = container.querySelector(`label[for="${firstAvailableColorInput.id}"]`);
              if (colorLabel) {
                colorLabel.dispatchEvent(new MouseEvent('click', {
                  view: window,
                  bubbles: true,
                  cancelable: true
                }));
              }
            }

            updateSelectedOptionLabels(container);
          }, 100);
        });
      });

      // 🛠️ Update "selected-option-value" next to each option title
      function updateSelectedOptionLabels(container) {
        container = container || document;  // <== Fix: default to document if null

        const fieldsets = container.querySelectorAll('fieldset[class*="fieldset-"]');

        fieldsets.forEach((fieldset) => {
          const match = fieldset.className.match(/fieldset-([a-zA-Z0-9_-]+)/);
          if (!match) return;

          const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
          const labelSpan = fieldset.querySelector('legend .selected-option-value');

          if (selectedInput && labelSpan) {
            labelSpan.textContent = selectedInput.value;
          }
        });
      }

      // 🔁 Update when any radio option changes
      document.querySelectorAll('input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => {
          updateSelectedOptionLabels(input.closest('form'));
        });
      });

      // ⚡ Initial update on page load
      updateSelectedOptionLabels();
    });


// HANDLE QUANTITYSELECTOR-PRICE for non-variation PDP

document.addEventListener('DOMContentLoaded', function () {
  const quantityInput = document.querySelector('.quantity__input');
  const addToCartButton = document.querySelector('.product-form__submit');

  if (!quantityInput || !addToCartButton) return;

  const isVisible = (elem) =>
    !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

  if (!isVisible(quantityInput)) return;

  const originalButtonHTML = addToCartButton.innerHTML;

  // Gets the correct price from sale or regular DOM elements
  const getSinglePrice = () => {
    let priceEl =
      document.querySelector('.price-item--sale') ||
      document.querySelector('.price-item--regular');

    if (!priceEl) return 0;

    let priceText = priceEl.textContent.trim().replace(/[^0-9.]/g, '');
    return parseFloat(priceText);
  };

  const formatPrice = (amount) => {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'USD', // You can dynamically change this if needed
    }).format(amount);
  };

  const updateButtonText = () => {
    const quantity = parseInt(quantityInput.value, 10) || 1;
    const pricePerUnit = getSinglePrice();
    const total = pricePerUnit * quantity;
    const totalFormatted = formatPrice(total);

    let newText = `Add ${quantity} to cart – ${totalFormatted}`;
    if (quantity === 1) newText = `Add to cart – ${totalFormatted}`;

    const span = addToCartButton.querySelector('span:not(.loading__spinner)');
    if (span) span.textContent = newText;
  };

  quantityInput.addEventListener('input', updateButtonText);

  const quantityButtons = quantityInput.closest('quantity-input').querySelectorAll('.quantity__button');
  quantityButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(updateButtonText, 50);
    });
  });

  updateButtonText(); // Initial run
});

